const initState = {
  quizError: null,
  quizMessage: null,
  quizMessagePopup: false,
  quizErrorPopup: false,
};

const quizReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CLOSE_QUIZ_POPUPS':
      return {
        ...state,
        quizErrorPopup: false,
        quizMessagePopup: false,
        quizError: null,
        quizMessage: null,
      };

    case 'QUIZ_CREATED':
      return {
        ...state,
        quizMessage: 'Your quiz has been created',
        quizMessagePopup: true,
      };
    case 'QUESTION_ADDED_TO_QUIZ':
      return {
        ...state,
        quizMessage: 'Question has been added',
        quizMessagePopup: true,
      };
    case 'ERROR_QUESTION_ADDED_TO_QUIZ':
      return {
        ...state,
        quizError: action.err.message,
        quizErrorPopup: true,
      };
    case 'QUESTION_HAS_BEEN_UPDATED':
      return {
        ...state,
        quizMessage: 'Question has been updated',
        quizMessagePopup: true,
      };
    case 'ERROR_UPDATING_QUESTION':
      return {
        ...state,
        quizError: action.err.message,
        quizErrorPopup: true,
      };
    default:
      return state;
  }
};

export default quizReducer;
